import { Fragment, useState, useEffect } from 'react';

import {
  BFAST_TAG_GROUP,
  SNACK_TAG_GROUP,
  POLARIZING_TAG_GROUP,
  MEAT_PROTEIN_TAG_GROUP,
  SEAFOOD_PROTEIN_TAG_GROUP,
  PLANT_PROTEIN_TAG_GROUP,
  showKidsSnacksFeature,
  fetchCustomerTags as getCustomerTags,
  getTagGroups,
  FoodQualitiesSection,
  FoodFormatSection,
  NutritionSection,
  IngredientsSection,
  CuisinesSection,
  FlavorsSection,
  SweetsSection,
  ReadyMadeSection,
  PolarizingPreferences,
  ProteinPreferences,
  GenericTagPreferences,
  DishtypePreferencesSection as DishtypePreferences,
  KidsSnacksSection,
} from '@hungryroot/app-mhr';
import { useIdentify } from '@hungryroot/rest-hooks';
import { useLunchDinnerFoodProfileSections } from '@hungryroot/plan';

const TagsSections = () => {
  const { customerData } = useIdentify();
  const customerId = customerData?.id;

  const lunchDinnerResult = useLunchDinnerFoodProfileSections(customerId);
  const { lunchSection, dinnerSection } = lunchDinnerResult || {};
  const isPricingVersion15or16 =
    lunchSection !== null && lunchSection !== undefined;
  const isLoadingPlanSections = lunchDinnerResult === undefined;

  const [customerTags, setCustomerTags] = useState([]);
  const [tagsByGroup, setTagsByGroup] = useState({
    [BFAST_TAG_GROUP]: [],
    [SNACK_TAG_GROUP]: [],
    [POLARIZING_TAG_GROUP]: [],
    [MEAT_PROTEIN_TAG_GROUP]: [],
    [SEAFOOD_PROTEIN_TAG_GROUP]: [],
    [PLANT_PROTEIN_TAG_GROUP]: [],
  });

  useEffect(() => {
    //getTags and customerTags and set them
    const newTagsByGroup = {};
    const tagGroupPromise = getTagGroups([
      BFAST_TAG_GROUP,
      SNACK_TAG_GROUP,
      POLARIZING_TAG_GROUP,
      MEAT_PROTEIN_TAG_GROUP,
      SEAFOOD_PROTEIN_TAG_GROUP,
      PLANT_PROTEIN_TAG_GROUP,
    ]);

    Promise.all([tagGroupPromise, getCustomerTags({ is_explicit: true })])
      .then(([tagsData, cTagsData]) => {
        tagsData.tag_groups.forEach((tagGroup) => {
          newTagsByGroup[tagGroup.id] = tagGroup.tags[0];
        });
        setTagsByGroup(newTagsByGroup);

        setCustomerTags(cTagsData.tags);
      })
      .catch(console.error);
  }, []);

  const getAllProteinsTags = () => {
    return [
      ...tagsByGroup[MEAT_PROTEIN_TAG_GROUP],
      ...tagsByGroup[SEAFOOD_PROTEIN_TAG_GROUP],
      ...tagsByGroup[PLANT_PROTEIN_TAG_GROUP],
    ];
  };

  return (
    <Fragment>
      <div className="hr-mb-32">
        <NutritionSection testid="nutrition-section" customerId={customerId} />
      </div>
      <div className="hr-mb-32">
        <FoodQualitiesSection
          testid="food-qualities-section"
          customerId={customerId}
        />
      </div>
      <div className="hr-mb-32">
        <FoodFormatSection
          testid="food-format-section"
          customerId={customerId}
        />
      </div>
      <div className="hr-mb-32">
        <CuisinesSection testid="cuisines-section" customerId={customerId} />
      </div>
      <div className="hr-mb-32">
        <FlavorsSection testid="flavors-section" customerId={customerId} />
      </div>
      <div className="hr-mb-32">
        <ProteinPreferences
          tags={getAllProteinsTags()}
          customerTags={customerTags}
        />
      </div>
      <div className="hr-mb-32">
        <IngredientsSection
          testid="ingredients-section"
          customerId={customerId}
        />
      </div>
      <div className="hr-mb-32">
        <PolarizingPreferences
          tags={tagsByGroup[POLARIZING_TAG_GROUP]}
          customerTags={customerTags}
        />
      </div>
      {!isLoadingPlanSections && !isPricingVersion15or16 && (
        <>
          <div className="hr-mb-32">
            <DishtypePreferences />
          </div>
          <div className="hr-mb-32">
            <ReadyMadeSection customerId={customerId} />
          </div>
        </>
      )}
      <div className="hr-mb-32">
        <GenericTagPreferences
          tags={tagsByGroup[BFAST_TAG_GROUP]}
          customerTags={customerTags}
          title="Breakfast Preferences"
          text="Set your preferences."
          icon={`/public/img/preferences/breakfast_icon.svg`}
          testId="generic-preferences-breakfast"
          subheadTitle="Do you like these kinds of breakfast foods?"
          subheadText="We’ll use your preferences to suggest more items that suit your tastes."
        />
      </div>

      {lunchSection && <div className="hr-mb-32">{lunchSection}</div>}

      {dinnerSection && <div className="hr-mb-32">{dinnerSection}</div>}

      <div className="hr-mb-32">
        <GenericTagPreferences
          tags={tagsByGroup[SNACK_TAG_GROUP]}
          customerTags={customerTags}
          title="Snack Preferences"
          text="Set your preferences."
          icon={`/public/img/preferences/snack_icon.svg`}
          testId="generic-preferences-snack"
          subheadTitle="Do you like these kinds of snacks?"
          subheadText="We’ll use your preferences to suggest more items that suit your tastes."
        />
      </div>
      <div className="hr-mb-32">
        <SweetsSection testid="sweets-section" customerId={customerId} />
      </div>
      <div className="hr-mb-32">
        <KidsSnacksSection
          testid="kids-snacks-section"
          customerId={customerId}
        />
      </div>
    </Fragment>
  );
};

export default TagsSections;
